import colors from './colors';
import images from './images';
import copy from './copy';

/** 定制金 — Figma「收银台 (定制主题)」 */
export default {
  id: 'custom-gold',
  name: 'Custom Gold',
  code: 'b96CAMpf',

  colors,
  copy,

  gradients: {
    card: `linear-gradient(180deg, ${colors.bgCard} 0%, ${colors.bgSecondary} 100%)`,
    header: `linear-gradient(180deg, ${colors.primaryNavyDark} 0%, ${colors.primaryNavy} 100%)`,
    btnPrimary: `linear-gradient(180deg, ${colors.btnGradientStart} 0%, ${colors.btnGradientEnd} 100%)`,
    btnStrong: `linear-gradient(0deg, ${colors.btnStrongGradientEnd} 1.792%, ${colors.btnStrongGradientStart} 93.447%)`,
    copyBtn: `linear-gradient(0deg, ${colors.accentYellowDark} 1.792%, ${colors.accentYellow} 93.447%)`,
  },

  images,
};
